export class AuthenticationResponseResult {
    constructor(responseType, result) {
        this.ResponseType = responseType;
        this.Result = result;
    }
}
